import { Link } from "react-router-dom";

function NotFound() {
    return (
        <div className="min-h-screen bg-gray-900 text-white flex items-center justify-center px-6">
            <div className="max-w-md text-center">
                <p className="text-green-400 text-sm uppercase tracking-[0.3em] mb-4">404</p>
                <h1 className="text-4xl font-bold mb-4">Page not found</h1>
                <p className="text-gray-400 mb-8">
                    The page you requested does not exist or is no longer available.
                </p>
                <Link
                    to="/"
                    className="inline-flex items-center justify-center bg-green-600 hover:bg-green-700 text-white font-bold py-3 px-6 rounded transition"
                >
                    Go home
                </Link>
            </div>
        </div>
    );
}

export default NotFound;